module.exports = __webpack_public_path__ + "static/media/loading.0bb9e843.png";